import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import { memo } from "react";
import { SelectChipRemoveButton } from "~/components/Select/components/SelectChipRemoveButton";
import { SELECT_CHIP } from "~/components/Select/shared/testIDs";
export const selectChip = tailwindVariants({
    base: "my-[3px] mr-1.5 flex w-auto items-center justify-start rounded-full bg-grey-4 transition-colors",
    variants: {
        size: {
            medium: "px-1 py-0 text-12",
            large: "px-2 py-0.5 text-12",
            "extra-large": "px-3 py-1.5 text-14"
        }
    },
    defaultVariants: {
        size: "large"
    }
});
const makeCustomStyles = (chip)=>({
        ...chip.backgroundHexColor && {
            backgroundColor: chip.backgroundHexColor
        },
        ...chip.borderRadius && {
            borderRadius: chip.borderRadius
        }
    });
const _SelectChip = (param)=>{
    let { chip, onDeselect, "data-testid": testId = SELECT_CHIP, size = "large" } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: selectChip({
            size
        }),
        style: makeCustomStyles(chip),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "truncate text-[length:inherit] font-medium text-grey-11",
                "data-testid": "".concat(testId, "-").concat(chip.label),
                style: {
                    color: chip.fontHexColor
                },
                children: chip.label
            }),
            !!onDeselect && /*#__PURE__*/ _jsx(SelectChipRemoveButton, {
                chip: chip,
                onClick: onDeselect
            })
        ]
    });
};
export const SelectChip = /*#__PURE__*/ memo(_SelectChip);
